import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import FaceRoi from './face-roi.vue';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
let default_1 = class default_1 extends Vue {
    dialogItem;
    canvas;
    matchThresh;
    faceVisible = true;
    id = '1';
    showDialog() {
        let item = this.dialogItem;
        let fromX = item.faceBoundingPoly.vertices[0].x * 606;
        let fromY = item.faceBoundingPoly.vertices[0].y * 350;
        let toX = item.faceBoundingPoly.vertices[2].x * 606;
        let toY = item.faceBoundingPoly.vertices[2].y * 350;
        let width = Math.abs(toX - fromX);
        let height = Math.abs(toY - fromY);
        this.draw(fromX, fromY, width, height);
    }
    draw(fromX, fromY, width, height) {
        let canvas = document.getElementById(this.id);
        setTimeout(() => {
            canvas = document.getElementById(this.id);
            let cxt = canvas.getContext('2d');
            canvas.width = 606;
            canvas.height = 350;
            cxt.lineWidth = 2;
            cxt.strokeStyle = 'red';
            cxt.strokeRect(fromX, fromY, width, height);
        }, 1);
    }
    closeDialog() {
        this.$emit('closedialogs');
    }
};
__decorate([
    Prop()
], default_1.prototype, "dialogItem", void 0);
__decorate([
    Ref()
], default_1.prototype, "canvas", void 0);
__decorate([
    Prop()
], default_1.prototype, "matchThresh", void 0);
default_1 = __decorate([
    Component({
        name: 'faceRadio',
        components: {
            FaceRoi,
            InvisibleNumber
        },
        i18n: {
            messages: {
                'en-us': {
                    name: 'Name',
                    position: 'position',
                    regionalInvasion: 'Regional invasion',
                    faceControlRatio: 'Facial Matched Result',
                    overflowOfPeople: 'Overflow of people',
                    crowded: 'Crowded',
                    crowdgathering: 'Crowd gathering',
                    crowdSpreadOut: 'Crowd spread out',
                    crowdCountercurrent: 'Crowd countercurrent',
                    crowdRetention: 'Crowd retention',
                    distanceTooClose: 'Social distance too close',
                    missionName: 'Task Name',
                    taskType: 'Task Type',
                    deviceName: 'Device Name',
                    triggerTime: 'Created Time',
                    threshold: 'Threshold',
                    portraitLibrary: 'Portrait Library',
                    idPicture: 'ID Photo',
                    liveAvatar: 'Live Avatar',
                    numberThreshold: 'Threshold Number of People',
                    detentionTimeThreshold: 'Loitering Time Threshold',
                    currentNumber: 'Current number',
                    LengthOfStay: 'Length of stay',
                    people: 'people',
                    direction: 'Statistical direction',
                    statisticalTime: 'Statistical time',
                    overrunThreshold: 'Overrun threshold',
                    statistics: 'Statistics',
                    crossLine: 'Cross line direction indicator',
                    area: 'Area',
                    numberOfpeople: 'Number of people',
                    crowdDensity: 'Crowd density',
                    distanceThreshold: 'Distance threshold',
                    durationThreshold: 'Duration threshold',
                    distance: 'Distance',
                    duration: 'duration',
                    alarmMethod: 'Alarm method',
                    numberOfUpstream: 'Number of upstream',
                    socialDistance: 'Social distance threshold',
                    positiveDirection: 'Positive direction indicator',
                    faceWarning: 'Facial Matched Alert',
                },
                zh: {
                    name: '姓名',
                    position: '位置',
                    regionalInvasion: '区域入侵',
                    faceControlRatio: '人脸布控比中',
                    overflowOfPeople: '人流量超限',
                    crowded: '人群过密',
                    crowdgathering: '人群聚集',
                    crowdSpreadOut: '人群散开',
                    crowdCountercurrent: '人群逆流',
                    crowdRetention: '人群滞留',
                    distanceTooClose: '社交距离过近',
                    missionName: '任务名称',
                    taskType: '任务类型',
                    deviceName: '设备名称',
                    triggerTime: '触发时间',
                    threshold: '阈值',
                    portraitLibrary: '人像库',
                    idPicture: '证件头像',
                    liveAvatar: '现场头像',
                    numberThreshold: '人数阈值',
                    detentionTimeThreshold: '滞留时长阈值',
                    currentNumber: '当前人数',
                    LengthOfStay: '滞留时长',
                    people: '人',
                    direction: '统计方向',
                    statisticalTime: '统计时长',
                    overrunThreshold: '超限阈值',
                    statistics: '统计人数',
                    crossLine: '跨线方向标识',
                    area: '区域面积',
                    numberOfpeople: '人数',
                    crowdDensity: '人群密度',
                    distanceThreshold: '距离阈值',
                    durationThreshold: '时长阈值',
                    distance: '距离',
                    duration: '时长',
                    alarmMethod: '告警方式',
                    numberOfUpstream: '逆流人数',
                    socialDistance: '社交距离阈值',
                    positiveDirection: '正方向标识',
                    faceWarning: '人脸比中告警',
                },
            },
        },
    })
], default_1);
export default default_1;
